module.exports = __webpack_public_path__ + "static/media/EntItem_elGoogleQRcode_51593.012320d5.jpg";